import * as React from 'react';
import { RetsinfoHarvestRecord, RetsinfoRecordFlagValue } from '../../../../../amorg-common';
import { CountAvatar } from '../../../../../designSystem/avatar/CountAvatar';
import { Button } from '../../../../../designSystem/button/Button';
import { AnimatedCollapsibleContent } from '../../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { H3 } from '../../../../../designSystem/typography/Heading';
import { toDateString } from '../../../../../utils/date';
import { CooldownButton } from './CooldownButton';
import { RetsInfoDocumentPanel } from './RetsInfoDocumentPanel';
import { retsinfoHelper } from './retsinfoHelper';
import { Card } from '../../../../../designSystem/Card';

type DateRecordPanelProps = {
    date: Date;
    cooldown: number;
    showHidden: boolean;
    record: RetsinfoHarvestRecord | null;
    onClickFetch: (date: Date) => Promise<void>;
    onClickRefetch: (date: Date) => Promise<void>;
    onClickRefetchDocument: (recordId: string, changeIndex: number) => void;
    onClickSetFlag: (changeIndex: number, flagValue: RetsinfoRecordFlagValue) => void;
};
export function DateRecordPanel (props: DateRecordPanelProps): JSX.Element
{
    const [expanded, setExpanded] = React.useState<boolean>(true);

    const state = retsinfoHelper.getDateState(props.record, props.date);

    const hiddenChangesCount = props.record?.changes.filter(change => change.flag === 'hide').length || 0;
    const unhiddenChangesCount = props.record?.changes.filter(change => change.flag !== 'hide').length || 0;

    return (
        <Flex flexDirection='column' gap={8}>

            <Card variant='outlined' key={props.date.toString()}>
                <Flex flexDirection="column" gap={8}>

                    <H3>{toDateString(props.date)}</H3>

                    <Flex justifyContent='space-between' alignItems='center' gap={16}>
                        <div>

                            {state === 'no-record-outdated' &&
                                <div>Data kan ikke længere tilgås</div>}

                            {state === 'no-record' &&
                                <Flex gap={8} alignItems='center'>
                                    <div>Ingen data hentet for denne dato endnu</div>
                                    <CooldownButton cooldown={props.cooldown} icon='interface_actions_download' toolTipText='Hent data' onClick={() => props.onClickFetch(props.date)} />
                                </Flex>}

                            {state === 'no-changes' &&
                                <div>Ingen ændringer for denne dato</div>}

                            {(state === 'has-changes' || state === 'has-changes-outdated') &&
                                <Flex gap={8} alignItems='center'>
                                    <CountAvatar count={unhiddenChangesCount} size='24px' /> ændringer(er)
                                    {hiddenChangesCount > 0 &&
                                        <>
                                            <CountAvatar count={hiddenChangesCount} size='24px' /> skjult
                                        </>}
                                </Flex>}
                        </div>

                        <Flex gap={8} alignItems='center'>
                            {state === 'has-changes' &&
                                <CooldownButton cooldown={props.cooldown} icon='interface_actions_synchronize' toolTipText='Genindlæs data' onClick={() => props.onClickRefetch(props.date)} />}
                            {(state === 'has-changes' || state === 'has-changes-outdated') &&
                                <Button variant='outlined' icon={expanded ? 'caret_caretUp' : 'caret_caretDown'} toolTipText={expanded ? 'Skjul dokumenter' : 'Vis dokumenter'} onClick={() => setExpanded(!expanded)} />}
                        </Flex>
                    </Flex>
                </Flex>
            </Card>

            {(state === 'has-changes' || state === 'has-changes-outdated') &&
                <AnimatedCollapsibleContent open={expanded}>
                    <Flex flexDirection='column' gap={8}>
                        {props.record?.changes.map((change, index) =>
                        {                           
                            if (props.showHidden || change.flag !== 'hide')
                            {

                                const key = `${change.changeData.documentId}-${change.changeData.accessionsnummer}`;

                                return (
                                    <RetsInfoDocumentPanel key={key} 
                                        change={change}
                                        changeIndex={index}
                                        onClickRefetch={() => props.onClickRefetchDocument(props.record?.id || '', index)}
                                        onClickSetFlag={(value) => props.onClickSetFlag(index, value)} 
                                    />
                                );
                            }
                        })}
                    </Flex>
                </AnimatedCollapsibleContent>
            }

        </Flex>
    );
}